import { TaxListInfo } from '@products/models/tax-list-info';
import { TaxListInfoDTO } from '@products/types/dto/tax-list-info.dto.type';
import {
  AssetClass,
  FundId,
  FundShareClassId,
  ProductType,
  ShareClassCode,
  WebProductTaxonomy,
  ShareClassName,
} from '@types';
import { MapperFactory } from './mapper-factory';
import { Mapper, MapperParams } from './type.mapper';

export class TaxListInfoDataMapper extends Mapper<TaxListInfo[]> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(taxListInfoDTO: TaxListInfoDTO[]): TaxListInfo[] {
    const taxListInfoData: TaxListInfo[] = [];

    taxListInfoDTO.forEach((taxListInfoDTOElement: TaxListInfoDTO) => {
      const taxListInfo: TaxListInfo = this.createMapper(
        TaxListInfoMapper
      ).toDomain(taxListInfoDTOElement);

      if (taxListInfo) {
        taxListInfoData.push(taxListInfo);
      }
    });

    return taxListInfoData;
  }
}

export class TaxListInfoMapper extends Mapper<TaxListInfo> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  createShareclassKey(fundId: string, shclcode: string): FundShareClassId {
    return (shclcode ? `${fundId}-${shclcode}` : fundId) as FundShareClassId;
  }

  toDomain(taxListInfoDTO: TaxListInfoDTO): TaxListInfo {
    const fundId = taxListInfoDTO.fundid as FundId;
    const shareClassKey = this.createShareclassKey(
      taxListInfoDTO.fundid,
      taxListInfoDTO.shclcode
    );

    return {
      fundId,
      shareClassCode: taxListInfoDTO.shclcode as ShareClassCode,
      fundName: taxListInfoDTO.fundname,
      taxYear: taxListInfoDTO.taxyear,
      foreignSourceIncome: taxListInfoDTO.frgnsrcincm,
      foreignSourceQualifiedDividends: taxListInfoDTO.frgnsrcqualifieddivinc,
      directUSGovernmentObligations: taxListInfoDTO.directusgovtobligations,
      specifiedPvtActivityBondInterest: taxListInfoDTO.specifiedpvtbondinterest,
      dividendsReceivedDeduction: taxListInfoDTO.dividendsreceiveddeduction,
      section163: taxListInfoDTO.section163,
      indianaResidentTaxableIncome: taxListInfoDTO.indianaresdtaxincm,
      utahResidentTaxableIncome: taxListInfoDTO.utahresdtaxincm,
      stateFlag: taxListInfoDTO.stateflag?.toLowerCase() === 'true',
      primaryShareClass: taxListInfoDTO.prmryshclind,
      assetClass: taxListInfoDTO.assetclass as AssetClass,
      investmentGroup: taxListInfoDTO.investmentgroup,
      productType: taxListInfoDTO.producttype as ProductType,
      cusip: taxListInfoDTO.cusip,
      ticker: taxListInfoDTO.ticker,
      taId: taxListInfoDTO.taid,
      productTaxonomy: taxListInfoDTO.webprdcttaxonomy as WebProductTaxonomy,
      primaryShareClassIndicator:
        taxListInfoDTO.prmryshclind?.toLowerCase() === 'yes',
      shareClassName: taxListInfoDTO.shareclassname as ShareClassName,
      shareClassKey,
      isSoftLaunchShareClass:
        this.mapperParams?.config?.isSoftLaunchShareClass(shareClassKey) ||
        false,
    };
  }
}
